/* @jsx h */
import { useMenu } from "@app/vue/providers/index";
import { defineComponent, ref, h, watch } from "vue";
import { useLocalization } from "@lemmonhq/uikit";

export const NotesSection = defineComponent({
  setup() {
    const { cart } = useMenu();
    const { t } = useLocalization();
    const isExpanded = ref(false);
    const notes = ref(cart.cart.orderNotes || "");

    // Watch for changes and update cart
    watch(notes, (newNotes) => {
      cart.cart.orderNotes = newNotes;
    });

    // Initialize from cart if it has notes
    if (cart.cart.orderNotes) {
      isExpanded.value = true;
    }

    return () => (
      <div class="p-2 ">
        {!isExpanded.value ? (
          <button
            class="btn btn-secondary btn-block"
            onClick={() => (isExpanded.value = true)}
          >
            <span class="material-symbols-outlined mr-2">add_comment</span>
            {t("customer.checkout.add_notes")}
          </button>
        ) : (
          <div class="space-y-2">
            <div class="flex justify-between items-center">
              <h3 class="text-lg font-semibold">
                {t("customer.checkout.order_notes")}
              </h3>
              <button
                class="btn btn-ghost btn-sm"
                onClick={() => (isExpanded.value = false)}
              >
                <span class="material-symbols-outlined">close</span>
              </button>
            </div>
            <textarea
              v-model={notes.value}
              class="textarea textarea-bordered w-full"
              placeholder={t("customer.checkout.special_instructions")}
              rows="3"
            />
          </div>
        )}
      </div>
    );
  },
});
